var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"myIframe",attrs:{"width":"100%","src":"/aps2.htm","scrolling":"no"},on:{"load":_vm.adjustIframeHeight}}),_c('tci-contact-footer',{ref:"targetFooter",attrs:{"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }